export default "__VITE_ASSET__Bl7I2Tws__"